import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClasses = {
    sm: { dot: 'h-1 w-1', gap: 'gap-0.5' },
    md: { dot: 'h-1.5 w-1.5', gap: 'gap-1' },
    lg: { dot: 'h-2 w-2', gap: 'gap-1.5' }
  };

  const { dot, gap } = sizeClasses[size];

  return (
    <div
      className={cn('flex items-center', gap, className)}
      role="status"
      aria-label="Loading"
    >
      <div className={cn(dot, 'rounded-full bg-current animate-bounce [animation-delay:-0.3s]')} />
      <div className={cn(dot, 'rounded-full bg-current animate-bounce [animation-delay:-0.15s]')} />
      <div className={cn(dot, 'rounded-full bg-current animate-bounce')} />
    </div>
  );
}
